import { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { MenuSettingsPanel } from '@shared/components/Menu/MenuSettingsPanel';
import { useSystemInfo } from '@shared/hooks/useSystemInfo';
import { formatVersionLabel } from '@shared/utils/buildInfo';
import { AboutModal } from './AboutModal';

interface SidebarFooterBarProps {
  /** Свёрнутый десктопный сайдбар: настройки меню недоступны, остаётся значок «О системе» */
  collapsed: boolean;
  isMobile: boolean;
}

/** Низ сайдбара: настройки меню слева, версия справа; клик по версии открывает «О системе». */
export function SidebarFooterBar({ collapsed, isMobile }: SidebarFooterBarProps) {
  const { t } = useTranslation(['translation']);
  const { data: info, isLoading } = useSystemInfo();
  const [aboutOpen, setAboutOpen] = useState(false);
  const label = formatVersionLabel(info?.version);
  const aboutTitle = t('about.open');
  const touch = isMobile ? { minHeight: 44, minWidth: 44 } : undefined;

  return (
    <div
      className="sidebar-footer-bar"
      style={{
        display: 'flex',
        flexDirection: collapsed ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'space-between',
        gap: 4,
        flexShrink: 0,
        borderTop: '1px solid var(--ant-color-split, rgba(5,5,5,0.06))',
        padding: '4px 8px',
        paddingBottom: isMobile
          ? 'calc(4px + env(safe-area-inset-bottom, 0px))'
          : 4,
      }}
    >
      {!collapsed && <MenuSettingsPanel compact />}
      <Tooltip title={aboutTitle} placement="right">
        <Button
          type="text"
          size="small"
          aria-label={label ? `${aboutTitle}: ${label}` : aboutTitle}
          aria-haspopup="dialog"
          onClick={() => setAboutOpen(true)}
          icon={collapsed || !label ? <InfoCircleOutlined /> : undefined}
          style={{ ...touch, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          {!collapsed && (
            <span className="font-mono" style={{ fontSize: 12 }}>
              {isLoading ? '' : label}
            </span>
          )}
        </Button>
      </Tooltip>
      <AboutModal open={aboutOpen} onClose={() => setAboutOpen(false)} info={info} />
    </div>
  );
}
